module.exports = __webpack_public_path__ + "img/7A7A7A_D0D0D0_BCBCBC_B4B4B4-256px.523cf058.png";